// extracted by mini-css-extract-plugin
export var compactFilters = "_ct-4";
export var detailImage = "_ct-1";
export var dropdownContainer = "_ct-2";
export var imageContainer = "_ct-0";
export var selectedCard = "_ct-3";